import classNames from 'classnames';
import { FunctionalComponent, h } from 'preact';

type Props = {
    center?: boolean;
    children?: any;
    className?: string;
    offset?: number;
    width?: number;
    sm?: number;
    md?: number;
    lg?: number;
};

export const Grid: FunctionalComponent<Props> = ({
    width = 12,
    sm = 0,
    md = 0,
    lg = 0,
    className,
    offset = 0,
    center = false,
    children,
}) => (
    <div
        className={classNames(className, 'l-grid', {
            'l-grid--center': center,
        })}
    >
        <div
            className={classNames(`l-grid__col-${width}`, {
                [`l-grid__offset--${offset}`]: offset,
                [`sm:l-grid__col-${sm}`]: sm,
                [`md:l-grid__col-${md}`]: md,
                [`lg:l-grid__col-${lg}`]: lg,
            })}
        >
            {children}
        </div>
    </div>
);
